/**
 * Retention Ops sidebar catalog.
 *
 * To add a screen:
 * 1. Add a key to AcademicLabels.
 * 2. Add a row here with that label, an icon, and a stateName.
 * 3. Add a child state under academicHome, an AngularJS host in framework-components.js,
 *    and an Angular page (or reuse s25-ng-academic-coming-soon until the screen is real).
 *
 * RETENTION_FORECAST is the short nav label for Whole Student Retention Analytics and Forecasting.
 */

import { S25Icons } from "../s25-icon/s25.icon.const";
import { S25States } from "../../services/state/state.map";
import { AcademicLabels } from "./academic.labels";

export type AcademicNavItem = {
    label: string;
    icon: S25Icons.Name;
    stateName: S25States.Name;
};

export const AcademicNavItems: AcademicNavItem[] = [
    {
        label: AcademicLabels.SECTION_SCHEDULING,
        icon: "calendar",
        stateName: S25States.names.academicSectionScheduling,
    },
    {
        label: AcademicLabels.INSTRUCTOR_SCHEDULING,
        icon: "users",
        stateName: S25States.names.academicInstructorScheduling,
    },
    {
        label: AcademicLabels.SCHEDULE_VALIDATION,
        icon: "checkCircle",
        stateName: S25States.names.academicScheduleValidation,
    },
    { label: AcademicLabels.CURRICULUM, icon: "bookmarkOutline", stateName: S25States.names.academicCurriculum },
    { label: AcademicLabels.CATALOG, icon: "search", stateName: S25States.names.academicCatalog },
    { label: AcademicLabels.RETENTION_FORECAST, icon: "reports", stateName: S25States.names.academicRetentionForecast },
];
